export default __webpack_public_path__ + "static/banner-image-91b6e3da2caca547498f0e2100c0fff1.png";